<template>
  <div>
    <CandidateLogMessagesBlock
      v-for="message in filteredMessages"
      :key="`${message.type}-${message.id}`"
      :message="message"
      :candidate="candidate"
      :vacancy="vacancy"
      :online-interview="candidate.interview"
      :show-review="showReview"
      :pdf-resume-loading="pdfResumeLoading"
      @show-interview="$emit('show-interview', $event)"
      @show-online-interview="$emit('show-online-interview')"
      @change-active-tab="$emit('change-active-tab', $event)"
      @generate-candidate-pdf="$emit('generate-candidate-pdf')"
    />
  </div>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api';
import CandidateLogMessagesBlock from './CandidateLogMessagesBlock.vue';
import { candidateLogType } from '../../enums';

export default {
  name: 'CandidateLogMessages',
  components: { CandidateLogMessagesBlock },
  props: {
    messages: {
      type: Array,
      required: true,
    },
    candidate: {
      type: Object,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
    onlineInterview: {
      type: Object,
      required: true,
    },
    showReview: {
      type: Boolean,
      required: true,
    },
    pdfResumeLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { candidate, messages } = toRefs(props);
    const transcriptions = computed(() => candidate.value?.interview?.timestamps?.some((i) => i.transcription !== null));

    const candidateCreatedAt = computed(() => candidate.value?.createdAt);
    const isCandidateAdditionalFields = computed(() => !!candidate.value.additionalFields);

    const messagesWithAddFields = computed(() => {
      return isCandidateAdditionalFields.value
        ? [
          {
            createdAt: candidateCreatedAt.value,
            eventType: 'candidate_additional_fields',
          },
          ...messages.value,
        ] : messages.value;
    });

    const filteredMessages = computed(() => {
      return !transcriptions.value ? messagesWithAddFields.value.filter((message) => message.eventType !== candidateLogType.INTERVIEW_TRANSCRIPTION_READY
        && message.eventType !== candidateLogType.AI_INTERVIEW_REVIEW_READY)
        : messagesWithAddFields.value.filter((message) => message.eventType !== candidateLogType.INTERVIEW_TRANSCRIPTION_READY);
    });

    return {
      filteredMessages,
    };
  },
};
</script>
